import React, { ElementType, ReactNode } from 'react'
import className from 'classnames/bind'

import routesConstants from 'app/constants/routes.constants'

import GoBackButton from 'app/components/buttons/go-back-button/go-back-button.component'
import { Block, Text } from 'app/components/common/'
import Image from 'app/components/common/image/image.component'
import defaultRobotImage from 'app/components/errors/assets/robot-sad.svg'

import stylesModule from 'app/components/errors/error-component.module.scss'

const cx = className.bind(stylesModule)

type ErrorComponentProps = {
  title: string
  message?: string
  button?: boolean
  CustomButton?: ElementType
  topGoBack?: boolean
  onGoBack?: () => void
  robotImage?: string
  children?: ReactNode
}

/**
 * Error main block component
 * @component
 */
const ErrorComponent = ({
  title,
  message,
  button = false,
  CustomButton,
  topGoBack = false,
  onGoBack,
  robotImage,
  children,
}: ErrorComponentProps) => {
  function goBack() {
    if (onGoBack) {
      onGoBack()
      return
    }
    if (window.location.href.endsWith('/500')) return
    window.location.href = routesConstants.HOME
  }

  const BottomBackButton =
    button && !topGoBack ? (
      <GoBackButton
        className={cx('button--oval-blue', 'error-component__go-back-button')}
        onClick={goBack}
      />
    ) : null

  return (
    <>
      {topGoBack && (
        <GoBackButton
          className={cx('button--oval-blue', 'error-component__top-go-back')}
          onClick={goBack}
        />
      )}
      <Block className={cx('error-component')}>
        <Image
          className={cx('error-component__robot-image')}
          src={robotImage || defaultRobotImage}
          alt="robot malfunction"
        />

        <Block className={cx('error-component__text-container')}>
          <Text type="h1" className={cx('error-component__title')}>
            {title}
          </Text>
          {children ||
            (message && (
              <Text type="p" className={cx('error-component__message')}>
                {message}
              </Text>
            ))}
        </Block>
      </Block>
      {BottomBackButton}
      {CustomButton && <CustomButton />}
    </>
  )
}

export default ErrorComponent
